import React from 'react';
import Button from '../components/Button';
import { Link } from 'react-router-dom';

const About: React.FC = () => {
  return (
    <div className="min-h-screen bg-black">
      {/* Hero Section */}
      <div className="relative pt-20 py-20 mt-10 bg-gradient-to-b from-black to-gray-900">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-semibold text-white mb-6 text-glow">
            MEET YOUR COACH
          </h1>
          <div className="w-16 h-1 bg-red-600 mx-auto mb-8"></div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16">
        {/* Main Content - Two Column Layout */}
        <div className="grid md:grid-cols-2 gap-12 mb-16">
          {/* Image Column */}
          <div className="relative">
            <div className="aspect-[3/4] overflow-hidden rounded-lg">
              <img
                src="/kabout.JPG"
                alt="Kelvin Kirk - Personal Trainer"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            {/* Red Accent Border */}
            <div className="absolute -bottom-4 -right-4 w-2/3 h-2/3 border-2 border-red-600 rounded-lg -z-10"></div>
          </div>

          {/* Text Column */}
          <div className="flex flex-col justify-center">
            <h2 className="text-2xl md:text-3xl font-semibold text-white mb-6">
              BIT MORE ABOUT ME
            </h2>
            <div className="space-y-4 text-gray-300">
              <p>
                KELVIN KIRK:
              </p>
              <p>
                With over 3 years of experience in personal training and body transformation, 
                I've helped hundreds of clients achieve their dream physiques and optimal health.
              </p>
              <p>
                My approach combines cutting-edge training techniques with personalized nutrition 
                plans, ensuring each client receives a program tailored to their unique needs and goals.
              </p>
              <p>
                As your coach, I'm not just here to count your reps – I'm here to guide you through 
                a complete transformation journey, both physical and mental. My commitment is to help 
                you build not just a better body, but a stronger, more confident version of yourself.
              </p>
              <p>
                Whether your goal is fat loss, muscle gain, or overall fitness improvement, 
                I'll provide you with the tools, knowledge, and support needed to succeed.
              </p>
            </div>

            {/* Credentials Section */}
            <div className="mt-8">
              <h3 className="text-xl font-semibold text-white mb-4">CERTIFICATIONS & ACHIEVEMENTS</h3>
              <ul className="list-none space-y-2 text-gray-300">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-red-600 rounded-full mr-3"></span>
                  Certificate 3 in Sports and Recreation
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-red-600 rounded-full mr-3"></span>
                  1 year work experience at PEAQ (#1 rated gym in South Australia)
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-red-600 rounded-full mr-3"></span>
                  Strength & Conditioning Expert
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-red-600 rounded-full mr-3"></span>
                  3+ Years Industry Experience
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-b from-gray-900 to-black py-20 -mx-4">
          <div className="container mx-auto px-4 text-center">
            <div className="relative inline-block">
              <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-16 h-1 bg-red-600"></div>
              <Link to="/contact">
                <Button>WORK WITH KELVIN</Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 
